/* Side cart drawer.
   Catches every add-to-cart form (cards and product page), adds with
   the AJAX cart API, then opens the drawer instead of going to /cart.
   The header Cart link opens the drawer too. */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root) return;
  var body = root.querySelector('[data-cd-body]');
  var foot = root.querySelector('[data-cd-foot]');
  var totalEl = root.querySelector('[data-cd-total]');
  var msgEl = root.querySelector('[data-cd-msg]');
  var fmt = root.getAttribute('data-money') || '${{amount}}';
  var lastFocus = null;

  function money(cents) {
    var n = (cents / 100);
    function d(v, dec, th, sep) {
      var p = v.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      return d(n, 2, ',', '.');
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function setCount(n) {
    document.querySelectorAll('.cart-link').forEach(function (a) {
      a.textContent = 'Cart (' + n + ')';
    });
  }

  function render(cart) {
    setCount(cart.item_count);
    msgEl.hidden = true;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cd-empty">Nothing in here yet.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-var">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' +
        '<a class="cd-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" width="72" height="72">' : '') + '</a>' +
        '<div class="cd-info">' +
          '<a class="cd-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="cd-row">' +
            '<div class="cd-qty">' +
              '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="One less">&minus;</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button>' +
            '</div>' +
            '<div class="cd-price">' + money(it.final_line_price) + '</div>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-q="0">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    totalEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function showError(text) {
    msgEl.textContent = text;
    msgEl.hidden = false;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; /* commit the closed position so the slide animates */
    root.classList.add('open');
    document.documentElement.classList.add('cd-lock');
    root.querySelector('.cd-close').focus();
  }
  function close() {
    root.classList.remove('open');
    document.documentElement.classList.remove('cd-lock');
    setTimeout(function () { if (!root.classList.contains('open')) root.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var b = e.target.closest('[data-q]');
    if (!b) return;
    var item = b.closest('.cd-item');
    item.classList.add('busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-q'), 10) })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { item.classList.remove('busy'); showError(res.j.description || res.j.message || 'Could not update the cart.'); return; }
        render(res.j);
      })
      .catch(function () { item.classList.remove('busy'); showError('Could not update the cart.'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) close();
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.cart-link');
    if (!a) return;
    e.preventDefault();
    refresh();
    open();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action)) return;
    if (e.submitter && e.submitter.getAttribute('formaction')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('busy'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return refresh().then(function () {
          if (!res.ok) showError(res.j.description || res.j.message || 'Could not add that to the cart.');
          open();
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('busy'); } });
  });
})();
